import API from 'js/lib/api';

import { naptimeForumTypes } from 'bundles/discussions/constants';

const courseFollowApi = API('/api/onDemandCourseForumQuestionFollowings.v1/', {
  type: 'rest',
});

const mentorFollowApi = API('/api/onDemandMentorForumQuestionFollowings.v1/', {
  type: 'rest',
});

const groupFollowApi = API('/api/onDemandGroupForumQuestionFollowings.v1/', {
  type: 'rest',
});

const chooseApi = (forumType: $TSFixMe) => {
  switch (forumType) {
    case naptimeForumTypes.mentorForumType:
      return mentorFollowApi;
    case naptimeForumTypes.groupForumType:
      return groupFollowApi;
    default:
      return courseFollowApi;
  }
};

export const follow = (post: $TSFixMe) => {
  return Promise.resolve(chooseApi(post.forumType).put(post.id));
};

export const unfollow = (post: $TSFixMe) => {
  return Promise.resolve(chooseApi(post.forumType).delete(post.id));
};
